import type { GridColDef } from '@mui/x-data-grid-pro';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import type { GlobalSearchSkill } from '../../../data-contract/global-search';
import { SkillChipWithDrawer } from '../../common/skills/SkillChipWithDrawer';
import { SkillGapPercentage } from './SkillGapPercentage';
import { SkillsBarChartDataGridCell } from './SkillsBarChartDataGridCell';
import { SkillsBarChartDataGridHeader } from './SkillsBarChartDataGridHeader';

type SkillsColumnsProps = {
    readonly openRowId?: string;
    readonly withLearningOpportunities: boolean;
};

export const SkillsBarChartColumns = ({
    openRowId,
    withLearningOpportunities,
}: SkillsColumnsProps): GridColDef<GlobalSearchSkill>[] => {
    const { translate } = useContext(ApplicationContext);

    return [
        {
            disableColumnMenu: true,
            field: 'title',
            flex: 1,
            headerName: translate('pages.global-search.headlines.skill'),
            maxWidth: 360,
            renderCell: (params) => {
                const skill = params.row;

                return (
                    <SkillChipWithDrawer
                        isSynced={skill.isSynced}
                        label={skill.title}
                        skillId={skill.id}
                        type={skill.skillType}
                    />
                );
            },
            resizable: false,
            sortable: false,
            valueGetter: ({ row }) => row,
        },
        {
            disableColumnMenu: true,
            field: 'barChart',
            renderCell: (params) => {
                const skill = params.row;

                return (
                    <SkillsBarChartDataGridCell
                        isRowOpen={skill.id === openRowId}
                        skill={skill}
                        withLearningOpportunities={withLearningOpportunities}
                    />
                );
            },
            renderHeader: () => <SkillsBarChartDataGridHeader withLearningOpportunities={withLearningOpportunities} />,
            resizable: false,
            sortable: false,
            width: 660,
        },
        {
            align: 'right',
            disableColumnMenu: true,
            field: 'skillGapRelative',
            headerName: translate('pages.global-search.headlines.skill-gap-relative'),
            renderCell: (params) => <SkillGapPercentage skill={params.row} />,
            resizable: false,
            sortable: false,
        },
    ];
};
